import httpInstance from "../httpInstance";

export const postChangePWD = async (
  jwtToken: string,
  email: string,
  password: string
) => {
  let res: any;
  const endpoint = `userChangePWD/`;

  // Configura el encabezado de autorización con el token JWT
  const config = {
    headers: {
      Authorization: `${jwtToken}`,
    },
  };

  const body = {
    email: email,
    password: password,
  };

  await httpInstance
    .post(endpoint, body, config)
    .then((data) => {
      res = data;
    })
    .catch((error) => {
      res = error.response;
    });
  return res;
};
